<template>
  <v-container fill-height justify-center :class="`error-view error-view--${errorCode}`">
    <empty-state v-bind="currentError">
      <v-btn color="primary" :to="callToActionDestiny" exact>
        {{ callToActionText }}
      </v-btn>
    </empty-state>
  </v-container>
</template>

<script>
import store from '@/services/store';
import EmptyState from '@/components/EmptyState.vue';

export default {
  name: 'ErrorView',

  components: {
    EmptyState,
  },

  props: {
    errorCode: {
      type: String,
      default: '500',
    },
  },

  computed: {
    isLoggedIn: () => store.getters['auth/isLoggedIn'],
    callToActionText: (vm) => (vm.isLoggedIn ? 'Ir para a home' : 'Ir para o login'),
    callToActionDestiny: (vm) => (vm.isLoggedIn ? '/' : '/login'),

    errorProps: () => ({
      403: {
        icon: 'mdi-lock-alert',
        title: 'Accesso negado',
        message: 'Você não tem permissão para acessar esta página, contate um administrador.',
      },

      404: {
        icon: 'mdi-map-marker-off',
        title: 'Página não encontrada',
        message: 'A página que você tentou acessar não existe ou foi movida para uma nova URL.',
      },

      500: {
        icon: 'mdi-power-plug-off',
        title: 'Ops, algo deu errado!',
        message: 'Algo inesperado aconteceu. Por favor, tente novamente mais tarde.',
      },
    }),

    currentError: (vm) => vm.errorProps[vm.errorCode] ?? vm.errorProps[500],
  },
};
</script>
